module.exports = __webpack_public_path__ + "static/media/copylink.bd7bb78b.svg";